import ReactDOM from 'react-dom';
import Routes from './route'
import './index.css'
const renderAll = () => {
	ReactDOM.render(Routes, document.getElementById('root'));
}

renderAll();




// WEBPACK FOOTER //
// ./src/index.js